import Proptypes from "prop-types";
import AgreementDateSelect from "./AgreementDateSelect";
import AgreementStatusSelect from "./AgreementStatusSelect";
import AgreementTypeSelect from "./AgreementTypeSelect";

const AgreementFilters = ({
  previousSelectedAgreementType,
  previousSelectedStatus,
  previousSelectedExpirationDate,
  previousSelectedSignedDate,
  expirationDateOptions,
  signedDateOptions,
  previousSelectedSignedStartDate,
  previousSelectedSignedEndDate,
  previousSelectedExpirationStartDate,
  previousSelectedExpirationEndDate,
}) => (
  <>
    <AgreementTypeSelect previousSelectedAgreementType={previousSelectedAgreementType} />
    <AgreementStatusSelect previousSelectedStatus={previousSelectedStatus} />
    <AgreementDateSelect
      previousSelectedExpirationDate={previousSelectedExpirationDate}
      previousSelectedSignedDate={previousSelectedSignedDate}
      expirationDateOptions={expirationDateOptions}
      signedDateOptions={signedDateOptions}
      previousSelectedSignedStartDate={previousSelectedSignedStartDate}
      previousSelectedSignedEndDate={previousSelectedSignedEndDate}
      previousSelectedExpirationStartDate={previousSelectedExpirationStartDate}
      previousSelectedExpirationEndDate={previousSelectedExpirationEndDate}
    />
  </>
);

AgreementFilters.propTypes = {
  previousSelectedAgreementType: Proptypes.arrayOf(Proptypes.string),
  previousSelectedStatus: Proptypes.arrayOf(Proptypes.string),
  previousSelectedExpirationDate: Proptypes.arrayOf(Proptypes.string),
  previousSelectedSignedDate: Proptypes.arrayOf(Proptypes.string),
  previousSelectedSignedStartDate: Proptypes.arrayOf(Proptypes.string),
  previousSelectedSignedEndDate: Proptypes.arrayOf(Proptypes.string),
  previousSelectedExpirationStartDate: Proptypes.arrayOf(Proptypes.string),
  previousSelectedExpirationEndDate: Proptypes.arrayOf(Proptypes.string),
  signedDateOptions: Proptypes.arrayOf(Proptypes.shape({ label: Proptypes.string, value: Proptypes.string })),
  expirationDateOptions: Proptypes.arrayOf(
    Proptypes.shape({ label: Proptypes.string, value: Proptypes.string }),
  ),
};
AgreementFilters.defaultProps = {
  previousSelectedAgreementType: [],
  previousSelectedStatus: [],
  previousSelectedExpirationDate: [],
  previousSelectedSignedDate: [],
  previousSelectedSignedStartDate: [],
  previousSelectedSignedEndDate: [],
  previousSelectedExpirationStartDate: [],
  previousSelectedExpirationEndDate: [],
  signedDateOptions: [],
  expirationDateOptions: [],
};
export default AgreementFilters;
